import Button from "components/Button/Button";
import Card from "components/Card/Card";
import KaboodleModal from "components/Modals/KaboodleModal";

import { getDocumentTypeLabel } from "../../utils/documentTypeUtils";

import type { TocEntry } from "../../metadoc.types";
import type { GroupingSource } from "services/metadoc-api";

type DeleteTocEntryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entry: TocEntry | null;
  isDeleting?: boolean;
  groupingSource?: GroupingSource;
};

const DeleteTocEntryModal = ({
  isOpen,
  onClose,
  onConfirm,
  entry,
  isDeleting = false,
  groupingSource = "OPS",
}: DeleteTocEntryModalProps) => {
  if (!entry) return null;

  const pageRange =
    entry.endPage && entry.endPage !== entry.startPage
      ? `${entry.startPage}-${entry.endPage}`
      : `${entry.startPage}`;

  const displayLabel = getDocumentTypeLabel(entry.category);
  const modalHeading =
    groupingSource === "AI"
      ? "Delete Document Group and PDF Pages"
      : "Delete Document Group";

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button className="delete" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Confirm Delete"}
          </Button>
          <Button onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
        </div>
      }
    >
      <Card heading={modalHeading}>
        {groupingSource === "AI" ? (
          <p>
            Are you sure you want to delete this document group and its pages
            from the PDF?
          </p>
        ) : (
          <p>Are you sure you want to delete this document group?</p>
        )}
        <div className="note-preview">
          <strong>{displayLabel}</strong> (Pages {pageRange})
          {entry.provider && <div>{entry.provider}</div>}
        </div>
        {groupingSource === "AI" && (
          <p>
            This removes the table of contents entry and permanently deletes
            these pages from the PDF.
          </p>
        )}
        <p>This action cannot be undone.</p>
      </Card>
    </KaboodleModal>
  );
};

export default DeleteTocEntryModal;
